export default "__VITE_ASSET__C9bP_eC4__"